
    export enum EnumWorkflowType {
			Product = 0,
			Ingredient = 1,
    }